export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";